import { createConfig, http } from 'wagmi'
import { baseSepolia } from 'wagmi/chains'
import { coinbaseWallet, injected } from 'wagmi/connectors'

export const wagmiConfig = createConfig({
  chains: [baseSepolia],
  connectors: [injected(), coinbaseWallet({ appName: 'CryptoKet Monsters' })],
  transports: {
    [baseSepolia.id]: http(),
  },
})
